import React, { FC, useState, useEffect } from "react";
// import facebookSvg from "images/Facebook.svg";
// import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useDispatch, useSelector } from "react-redux";
import { userLogin, getUser } from "actions/userActions";
import { RootState } from "store";
import { useHistory } from "react-router-dom";
import { IInput, ILoginSocial } from "types/interfaces";
import { Alert } from "shared/Alert/Alert";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";

export interface PageLoginProps {
	className?: string;
}

const loginSocials: ILoginSocial[] = [
	{
		name: "Masuk melalui Google",
		icon: googleSvg,
		method: "google",
	},
	// {
	//   name: "Masuk melalui Facebook",
	//   icon: facebookSvg,
	//   method: "facebook",
	// },
	// {
	//   name: "Masuk melalui Twitter",
	//   icon: twitterSvg,
	//   method: "twitter",
	// },
];

const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {
	const history = useHistory();

	const [email, setEmail] = useState<IInput>({ value: "", warning: "" });
	const [password, setPassword] = useState<IInput>({ value: "", warning: "" });

	const dispatch = useDispatch();
	const { loading, userInfo, error } = useSelector(
		(state: RootState) => state.userInfo
	);

	const updatePasswordState = useSelector(
		(state: RootState) => state.userForgetPasswordUpdate
	);

	const handleLogin = (e: any) => {
		if (!email.value) {
			setEmail({ value: email.value, warning: "Masukkan email" });
		}

		if (!password.value) {
			setPassword({ value: password.value, warning: "Masukkan Password" });
		}

		if (email.value && password.value) {
			dispatch(userLogin(email.value, password.value));
		}

		e.preventDefault();
	};

	const handleAuth = async (method: string) => {
		logging("", {
			category: "user",
			action: "login",
			target: "google",
		});
		const popup = window.location.href.includes("localhost")
			? `http://localhost:8000/api/auth/${method}`
			: `https://rentrips.id/api/auth/${method}`;

		let timer: NodeJS.Timeout | null = null;
		const newWindow = window.open(popup, "_blank", "width=500,height=600");

		if (newWindow) {
			timer = setInterval(() => {
				if (newWindow.closed) {
					dispatch(getUser());
					if (timer) clearInterval(timer);
				}
			}, 500);
		}
	};

	useEffect(() => {
		if (userInfo) {
			const redirect = window.location.search?.split("=")[1] || "/";
			history.push(redirect);
		}
	}, [userInfo]);

	return (
		<div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
			<Helmet>
				<title>Masuk</title>
			</Helmet>
			<div className="container mb-24 lg:mb-32">
				{error && <Alert>{error}</Alert>}
				{updatePasswordState.status?.message && (
					<Alert type="success">{updatePasswordState.status.message}</Alert>
				)}
				<h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
					Masuk
				</h2>
				<div className="max-w-md mx-auto space-y-6">
					{/* FORM */}
					<form className="grid grid-cols-1 gap-6" onSubmit={handleLogin}>
						<label className="block">
							<span className="text-neutral-800 dark:text-neutral-200">
								Email
							</span>
							<Input
								type="email"
								placeholder="contoh@email.com"
								className="mt-1"
								value={email.value}
								onChange={(e) =>
									setEmail({ value: e.target.value, warning: "" })
								}
							/>
							{email.warning && (
								<span className="text-red-600 text-sm">{email.warning}</span>
							)}
						</label>
						<label className="block">
							<span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
								Password
							</span>
							<Input
								type="password"
								className="mt-1"
								placeholder="password"
								value={password.value}
								onChange={(e) =>
									setPassword({ value: e.target.value, warning: "" })
								}
							/>
							{password.warning && (
								<span className="text-red-600 text-sm">{password.warning}</span>
							)}
							<div className="relative mb-8">
								<Link
									to="/forget-password"
									className="text-sm text-right absolute right-0 top-2"
								>
									Lupa Password?
								</Link>
							</div>
						</label>
						<ButtonPrimary type="submit">
							{loading ? "Loading..." : "Masuk"}
						</ButtonPrimary>
					</form>
					{/* OR */}
					<div className="relative text-center">
						<span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
							ATAU
						</span>
						<div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
					</div>
					{/** SOCIAL */}
					<div className="grid gap-3">
						{loginSocials.map((item, index) => (
							<div
								key={index}
								onClick={
									() => {
										handleAuth(item.method);
										eventAnalytic({
											category: "User",
											action: "login",
											label: "Auth Google",
										});
									} /*dispatch(userAuth(item.method))*/
								}
								className="nc-will-change-transform flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
							>
								<img
									className="flex-shrink-0"
									src={item.icon}
									alt={item.name}
								/>
								<h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
									{item.name}
								</h3>
							</div>
						))}
					</div>

					{/* ==== */}
					<span className="block text-center text-neutral-700 dark:text-neutral-300">
						Pengguna Baru? {` `}
						<Link to={`/signup${window.location?.search || ""}`}>
							<strong>Buat Akun</strong>
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default PageLogin;
